<template>
  <div class="content">
    <h2 class="pl-3">{{ father }} | Promedios</h2>

    <v-card-title>
      <v-row align="end" justify="space-between">
        <v-col cols="6" offset-lg="3">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
        <v-col md="auto">
          <v-tooltip bottom class="text-right">
            <template v-slot:activator="{ on }">
              <v-btn color="blue-grey" class="ma-2 white--text" fab v-on="on" @click="descargarPDF">
                <v-icon dark>mdi-cloud-download</v-icon>
              </v-btn>
            </template>
            <span>Descargar Planilla</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="alumnos"
      :search="search"
      ref="lista_promedios"
      class="elevation-1 pa-3 ma-3"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
    >
      <template v-slot:items="props">
        <td>{{(props.index + 1)}}</td>
        <!--<td>{{pagination.page}}</td>-->
        <td class="text-xs-left">{{ mayus(props.item.nombre_alumno) }}</td>
        <td class="text-xs-left">{{ mayus(props.item.promedio) }}</td>
        <td class="text-xs-left">{{ mayus(props.item.curso) }}</td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import API from "@/components/_config/conf";

export default {
  data() {
    return {
      search: "",
      rowsPerPageItems: [10, 20, 50],
      pagination: {
        rowsPerPage: 10
      },
      headers: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: ""
        },
        {
          text: "Alumno",
          align: "left",
          sortable: false,
          value: "nombre_alumno"
        },
        {
          text: "Promedio",
          sortable: false,
          value: "promedio"
        },
        {
          text: "Curso",
          sortable: false,
          value: "curso"
        }
      ],
      alumnos: []
    };
  },
  props: ["father"],
  mounted: function() {
    this.$emit("promedios:mostrarOcultarPreload");
    let params = "parametro=''&curso=''";
    let resultado = API.enviar("get", "obtenerMejoresNota", params);
    resultado
      .then(result => {
        if (result.data.msj == "ok") this.alumnos = result.data.result;
        this.$emit("promedios:mostrarOcultarPreload");
      })
      .catch(() => {
        //console.log("catch obtenerMateriasDeProfesor-> params: ", params);
      });
  },
  methods: {
    mayus(str) {
      let srt_result = API.ucFirst(str);
      return srt_result;
    },
    descargarPDF: function() {
      console.log("descargarPDF Promedio", this.search);
      window.open(
        API.PORT +
          API.PATH +
          "?funcion=descargarReportePromedios&curso=" +
          this.search
      );
    }
  }
};
</script>

<style scoped>
.content {
  width: 100%;
}

h2 {
  padding-bottom: 20px;
}
</style>